import {
    GET_FOLLOWUP_REMINDER_LIST,
    GET_FOLLOWUP_REMINDER_LIST_SUCCESS,
    GET_FOLLOWUP_REMINDER_LIST_FAIL,
    UPDATE_FOLLOWUP_REMINDER,
    UPDATE_FOLLOWUP_REMINDER_SUCCESS,
    UPDATE_FOLLOWUP_REMINDER_FAIL,
  } from "./FollowUpRemindertypes"
  import { getReminderList, updateReminder } from "../../services/FollowUpReminderService"
  
  function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey
    if (stateToken) return stateToken
    const storedUser = localStorage.getItem("userDetails")
    return storedUser ? JSON.parse(storedUser).token : null
  }
  
  export const getFollowUpReminderListAction = () => {
    return async (dispatch, getState) => {
      dispatch({ type: GET_FOLLOWUP_REMINDER_LIST })
      try {
        const response = await getReminderList()
        // Fix: Access the correct data structure from your API response
        const reminderData = response.data?.data || []
        dispatch({
          type: GET_FOLLOWUP_REMINDER_LIST_SUCCESS,
          payload: reminderData,
        })
        return {
          success: true,
          data: reminderData,
        }
      } catch (error) {
        dispatch({
          type: GET_FOLLOWUP_REMINDER_LIST_FAIL,
          payload: error?.response?.data?.message || "Something went wrong",
        })
        return {
          success: false,
          error: error?.response?.data?.message || "Something went wrong",
        }
      }
    }
  }
  
  // Fix 3: Remove automatic list refresh - let the reducer handle state updates
  export const updateFollowUpReminderAction = (reminderId, status) => {
    return async (dispatch, getState) => {
      dispatch({ type: UPDATE_FOLLOWUP_REMINDER })
      try {
        const response = await updateReminder({
          reminder_id: reminderId,
          reminder_status: status,
        })
        dispatch({
          type: UPDATE_FOLLOWUP_REMINDER_SUCCESS,
          payload: { reminderId, status },
        })
  
        // Remove this line to prevent unnecessary API calls
        // dispatch(getFollowUpReminderListAction())
  
        return {
          success: true,
          data: response.data,
        }
      } catch (error) {
        dispatch({
          type: UPDATE_FOLLOWUP_REMINDER_FAIL,
          payload: error?.response?.data?.message || "Failed to update reminder",
        })
        return {
          success: false,
          error: error?.response?.data?.message || "Failed to update reminder",
        }
      }
    }
  }
  